import { Phone, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data";

export const MobileCTA = () => (
  <div data-testid="mobile-cta" className="md:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t-2 border-navy">
    <a
      href={CONTACT.phoneHref}
      data-testid="mobile-call-btn"
      className="h-16 bg-gold text-navy font-primary uppercase tracking-wide text-base flex items-center justify-center gap-2 active:bg-gold/80"
    >
      <Phone size={20} /> Call Now
    </a>
    <a
      href={CONTACT.smsHref}
      data-testid="mobile-text-btn"
      className="h-16 bg-navy text-ice font-primary uppercase tracking-wide text-base flex items-center justify-center gap-2 active:bg-navy/80"
    >
      <MessageSquare size={20} /> Text Us
    </a>
  </div>
);
